<template>
  <div id="main-wrap">
    <WebTools />
    <!--web nav-->
    <CspaWebMenu />

    <div class="body-wrap">
      <div class="">
        <div class="block-title-wrap">
          <div class="block-title">{{columnName}}</div>
        </div>
        <div class="column-list-wrap" v-if="list.length>0">
          
          <Row class="column-list-row-wrap" v-for="(item, index) in list" v-bind:key="index">
            <Col span="6" class="news-list-cover-wrap">
              <img class="news-list-cover" src="https://images-cspaxy.chinacspa.com/images/defaultpic.gif" >
              <!-- <a href="http://127.0.0.1:8081"></a> -->
              <router-link tag="a" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}" target="_blank"></router-link>
            </Col>
            <Col class="news-list-info-wrap" span="18">
              <router-link tag="h2" :to="{path: '/news/show', query:{id: item.newsId, sid: website}}">
                <a target="_blank">{{item.title}}</a>
              </router-link>
              <!-- <h2><a href="#">{{item.title}}</a></h2> -->
              <p>{{item.description}}</p>
              <div class="news-pub-date"><Icon type="ios-time-outline" />{{item.pubDate}}</div>
            </Col>
          </Row>
          
          <div class="columns-page"><Page :total="num" :page-size="10" show-total show-elevator @on-change="pageEvent" /></div>
        </div>
        
      </div>
    </div>
    
    <CspaWebFooter />
  </div>
</template>

<script>
import axios from "axios"
import WebTools from "@/components/WebTools.vue"
import CspaWebMenu from "@/components/CspaWebMenu.vue"
import CspaWebFooter from "@/components/CspaWebFooter.vue"
export default {
  name: 'Home',
  components: {
    WebTools,
    CspaWebMenu,
    CspaWebFooter
  },

  data() {
    return {
      website: 0,
      page: 1,
      columnId: 0,
      columnName:'',
      num: 0,
      list: []
    }
  },

  //页面加载完成执行
  mounted() {
    this.initPageData()

    this.initColumnNews()
  },

  //页面方法
  methods: {
    //初始化页面数据
    initPageData() {
      let sid = parseInt(this.$route.query.sid)
      if(!isNaN(sid) && sid>1) {
        this.website = sid
      } else {
        this.website = 0
      }

      let columnId = parseInt(this.$route.query.colid)
      if(!isNaN(columnId) && columnId>1) {
        this.columnId = columnId
      } else {
        this.columnId = 0
      }
    },

    //初始化页面新闻数据
    initColumnNews() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/columns/columns-news-list",
        {site: vm.website, page: vm.page, columnId: vm.columnId, status: 1},
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      ).then(function(res) {
        let errorCode = parseInt(res.data.code)
        if(!isNaN(errorCode) && errorCode==0) {
          let gotted = res.data.data
          //console.log(gotted)
          vm.columnName = gotted.columnName
          vm.list = gotted.list
          vm.num = gotted.num
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //分页事件
    pageEvent(page) {
      this.page = page
      this.initColumnNews()
    },


  }

}
</script>
